<template>
    <div class="pre-reg-forms">
        <span class="pre-reg-forms__heading">{{ heading }}</span>
        <p class="pre-reg-forms__body">Looks like there {{ str }} that you'll need to bring in with you to your first consultation.</p>
        <ul class="pre-reg-forms__list" v-if="forms.length">
            <li class="pre-reg-forms__form" v-for="(item, key) in forms">
                <a :href="item.url" class="pre-reg-forms__link" target="_blank">{{ item.title }}</a>
                <a :href="item.url" :download="item.title" class="pre-reg-forms__download"></a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: ['heading', 'forms'],
    data() {
        return {
            serviceForms: this.forms,
            str: ''
        }
    },
    watch: {
        forms: {
            immediate: true,
            handler(forms) {
                const n = forms.length;
                let string = this.str;

                if (n === 0) {
                    string = 'are no forms';
                } else if (n === 1) {
                    string = 'is 1 form';
                } else {
                    string = `are ${n} forms`;
                }

                this.str = string;
            }
        }
    }
}

</script>
